import React from "react";
import "./styles/ListingTable.css";
import { formatStoreCurrency } from "../../assets/currency";
import { useTranslation } from "react-i18next";

const PhysicalGcFulfillTable = ({ data, onFulfillClick }) => {
  const { t } = useTranslation();

  const handleFulfill = (row) => {
    if (onFulfillClick) {
      onFulfillClick(row);
    }
  };

  const isButtonDisabled = (row) => {
    const orderedQuantity = row?.quantity || 0;
    const fulfilledCards = row?.cards?.length || 0;
    return fulfilledCards >= orderedQuantity && orderedQuantity > 0;
  };

  const getButtonText = (row) => {
    const orderedQuantity = row?.quantity || 0;
    const fulfilledCards = row?.cards?.length || 0;

    if (fulfilledCards >= orderedQuantity && orderedQuantity > 0) {
      return "Fulfilled";
    }

    if (fulfilledCards > 0) {
      return `Fulfill (${fulfilledCards}/${orderedQuantity})`;
    }

    return "Fulfill";
  };

  /**
   * Combine AWB numbers and tracking URLs safely
   */
  const getAwbDetails = (row) => {
    const numbers = row?.tracking_numbers || [];
    const urls = row?.tracking_urls || [];

    return numbers.map((awb, index) => ({
      awb,
      url: urls[index] || "#",
    }));
  };

  return (
    <div className="table-wrapper">
      <table className="listing-table physical-gc-table">
        <thead>
          <tr>
            <th>{t("commonTexts.orderNo") || "Order No."}</th>
            <th>{t("commonTexts.orderDate") || "Order Date"}</th>
            <th>{t("commonTexts.customerName") || "Customer Name"}</th>
            <th>{t("commonTexts.orderValue") || "Order Value"}</th>
            <th>{t("commonTexts.paymentStatus") || "Payment Status"}</th>
            <th>{t("commonTexts.originalPayment") || "Original Payment"}</th>
            <th>AWB Number</th>
            <th>{t("commonTexts.fulfillmentStatus") || "Fulfillment Status"}</th>
          </tr>
        </thead>

        <tbody>
          {data && data.length > 0 ? (
            data.map((row, index) => {
              const disabled = isButtonDisabled(row);
              const awbDetails = getAwbDetails(row);

              return (
                <tr key={index}>
                  <td>#{row?.order_number}</td>
                  <td>{row?.created_at?.slice(0, 10)}</td>
                  <td>
                    {row?.customer?.first_name}{" "}
                    {row?.customer?.last_name}
                  </td>
                  <td>
                    {formatStoreCurrency(
                      parseFloat(row?.orderValue || 0).toFixed(2)
                    )}
                  </td>
                  <td>
                    <span
                      className={`status-badge status-${row?.paymentStatus?.toLowerCase()}`}
                    >
                      {row?.paymentStatus}
                    </span>
                  </td>
                  <td>{row?.paymentMethod}</td>

                  {/* AWB Numbers */}
                  <td>
                    {awbDetails.length > 0 ? (
                      <div className="awb-list">
                        {awbDetails.map(({ awb, url }, i) => (
                          <a
                            key={i}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="awb-link"
                            title="Track shipment"
                          >
                            {awb}
                          </a>
                        ))}
                      </div>
                    ) : (
                      <span className="no-awb">—</span>
                    )}
                  </td>

                  {/* Fulfill Button */}
                  <td className="gc-table__actions">
                    <button
                      className={`fulfill-btn ${
                        disabled ? "fulfilled" : ""
                      }`}
                      onClick={() => handleFulfill(row)}
                      disabled={disabled}
                      title={
                        disabled
                          ? "All gift cards have been fulfilled"
                          : "Click to fulfill remaining gift cards"
                      }
                    >
                      {getButtonText(row)}
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PhysicalGcFulfillTable;
